import i18n from 'i18next';
import Cookies from 'js-cookie';
import { initReactI18next } from 'react-i18next';
import {
  en,
  es,
  getNavigatorLanguage,
  id,
  ja,
  KEY_TRANSLATE_LANGUAGE,
  ko,
  my,
  ne,
  normalizeLanguages,
  pt,
  ptBR,
  SUPPORT_I18N_LANGUAGES,
  vi,
  zhHans,
} from '@mygpt/app';

const isLocalMode = import.meta.env.VITE_MODE === 'local';
// OnPrem 下只支持部分语言
const onPremSupportedLangs = ['ja', 'en', 'zh-Hant'];

// 语言设置使用 syncToCookie: false 保存到 localStorage，
// 所以读取时直接从 localStorage 读取，避免旧 cookie 干扰
const savedLang = localStorage.getItem(KEY_TRANSLATE_LANGUAGE);

// 清理历史遗留的语言 cookie（旧版本曾将语言保存到 cookie）
if (Cookies.get(KEY_TRANSLATE_LANGUAGE)) {
  Cookies.remove(KEY_TRANSLATE_LANGUAGE);
  Cookies.remove(KEY_TRANSLATE_LANGUAGE, { domain: '.gbase.ai', path: '/' });
  Cookies.remove(KEY_TRANSLATE_LANGUAGE, { domain: '.gptbase.ai', path: '/' });
}

// default lang
const lang = savedLang || normalizeLanguages(getNavigatorLanguage())[0];
// OnPrem 下如果用户语言不在支持列表中，回退到默认语言（ja）
const effectiveLang = isLocalMode && lang && !onPremSupportedLangs.includes(lang) ? onPremSupportedLangs[0] : lang;

if (effectiveLang) {
  const index = SUPPORT_I18N_LANGUAGES.indexOf(effectiveLang);
  if (index > 0) {
    [SUPPORT_I18N_LANGUAGES[0], SUPPORT_I18N_LANGUAGES[index]] = [
      SUPPORT_I18N_LANGUAGES[index],
      SUPPORT_I18N_LANGUAGES[0],
    ];
  }

  document.documentElement.lang = effectiveLang;
}

i18n
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    lng: effectiveLang, // 使用从 localStorage 读取的语言，刷新页面后保持语言设置
    load: 'currentOnly',
    supportedLngs: SUPPORT_I18N_LANGUAGES,
    partialBundledLanguages: true,
    fallbackLng: SUPPORT_I18N_LANGUAGES[0],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      'zh-Hans': {
        translation: zhHans,
      },
      ja: {
        translation: ja,
      },
      ko: {
        translation: ko,
      },
      en: {
        translation: en,
      },
      pt: {
        translation: pt,
      },
      'pt-BR': {
        translation: ptBR,
      },
      id: {
        translation: id,
      },
      ne: {
        translation: ne,
      },
      es: {
        translation: es,
      },
      vi: {
        translation: vi,
      },
      my: {
        translation: my,
      },
    },
  });
